<template>
  <v-container fill-height fluid class="pa-0">

    <!--FLOAT BUTTON-->
    <router-link
        v-if="$store.getters.getSettingValue('cartEnable')"
        :to="{ name: 'CustomerOrderPage' }"
    >
      <div class="btn btn-flotante text-center">REALIZAR <br/>PEDIDO</div>
    </router-link>

    <!--PARALAX-->
    <home-parallax></home-parallax>

    <home-message></home-message>


    <horneadas-congeladas></horneadas-congeladas>


    <home-masas-artesanales></home-masas-artesanales>


    <!--PRODUCTS-->
    <home-products></home-products>

    <info-image-alert
      v-if="!!alertHomeImage && infoAlertState"
      :text="infoAlertText"
      :alert-type="alertHomeType"
      :alert-font-size="alertHomeFontSize"
      :alert-image="alertHomeImage"
    ></info-image-alert>

    <info-alert
      v-else
      v-model="infoAlertState"
      :text="infoAlertText"
      :alert-type="alertHomeType"
      :alert-font-size="alertHomeFontSize"
    />
    
    <survey-response-bubble
    ></survey-response-bubble>
  </v-container>
</template>

<script>
import InfoImageAlert from "../../components/InfoAlert/InfoImageAlert.vue";
import HomeProducts from "../../../delivery/components/HomeProducts";
import HorneadasCongeladas from "@/modules/base/pages/HomePage/HorneadasCongeladas";
import HomeParallax from "@/modules/base/pages/HomePage/HomeParallax";
import HomeMessage from "@/modules/base/pages/HomePage/HomeMessage.vue";
import HomeMasasArtesanales from "@/modules/base/pages/HomePage/HomeMasasArtesanales";
import InfoAlert from '@/modules/base/components/InfoAlert'
import SurveyResponseBubble from '../../components/SurveyResponseBubble'

export default {
  name: "HomePage",
  data() {
    return {
      hover: true,
      alertHomeBoolean: false
    };
  },
  mounted() {
  },
  components: {
    HomeMasasArtesanales,
    HomeParallax,
    HomeMessage,
    HorneadasCongeladas,
    HomeProducts,
    InfoAlert,
    InfoImageAlert,
    SurveyResponseBubble
  },
  computed: {
    infoAlertState: {
      get() {
        return this.$store.getters.getSettingValue('alertHomeBoolean') || false
      },
      set(val) {
        this.$store.commit('setSetting', {key: 'alertHomeBoolean'}, val)
      }
    },
    infoAlertText() {
      return this.$store.getters.getSettingValue('alertHomeText')
    },
    alertHomeType() {
      return this.$store.getters.getSettingValue('alertHomeType')
    },
    alertHomeFontSize() {
      return this.$store.getters.getSettingValue('alertHomeFontSize')
    },
    alertHomeImage() {
      return this.$store.getters.getSettingValue('alertHomeImage')
    }
  }
};
</script>
<style scoped>


.btn-flotante {
  position: fixed;
  bottom: 40%;
  right: 0px;
  z-index: 100;
  background: #000;
  color: orange;
  font-size: 30px;
  line-height: 27px;
  font-weight: bolder;
  border-radius: 15px 0 0 15px;
  padding: 20px 40px 20px 25px;
  box-shadow: 5px 5px 10px rgb(71 71 71 / 50%);
}


</style>
